import React, { FunctionComponent, useReducer } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';

import { useMediaQueryContext } from '../../../../providers/MediaQueryProvider';

import { reducer, initialState } from './reducer';

const StyledCheckbox = styled(Checkbox)`
  background: rgb(255, 255, 255);
  border: solid rgba(0, 0, 0, 0.05) 1px;
  color: blue;
`;

export type Input = {
  email: string;
  name: string;
  ios: boolean;
  android: boolean;
};

type EmailInputForm = {
  submitting: boolean;
  onSubmit: (input: Input) => Promise<void>;
};

const EmailInputForm: FunctionComponent<EmailInputForm> = ({
  onSubmit,
  submitting,
}) => {
  const { formatMessage } = useIntl();
  const { width } = useMediaQueryContext();
  const [state, dispatch] = useReducer(reducer, initialState);

  const disabled = submitting || !state.isValid;

  const onChangeText = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    type: 'EMAIL' | 'NAME'
  ) => {
    dispatch({ type, payload: event.target.value });
  };

  const onChangeCheckbox = (type: 'IOS' | 'ANDROID', payload: boolean) => {
    dispatch({ type, payload });
  };

  return (
    <form
      method="post"
      onSubmit={async (event) => {
        event.preventDefault();
        await onSubmit(state);
        dispatch({ type: 'RESET' });
      }}
    >
      <Box display={width < 640 ? 'block' : 'flex'} mt={4}>
        <TextField
          fullWidth
          id="name"
          label={formatMessage({ id: `contact.name` })}
          margin="normal"
          onChange={(event) => onChangeText(event, 'NAME')}
          value={state.name}
        />
        <Box mx={2} />
        <TextField
          fullWidth
          id="email"
          label={formatMessage({ id: `contact.email` })}
          margin="normal"
          onChange={(event) => onChangeText(event, 'EMAIL')}
          value={state.email}
        />
      </Box>

      <Box display="flex" justifyContent="space-between" mt={2}>
        <Box display="flex">
          <FormControlLabel
            control={
              <StyledCheckbox
                checked={state.ios}
                onChange={() => onChangeCheckbox('IOS', !state.ios)}
                name="ios"
              />
            }
            label="iOs"
          />
          <FormControlLabel
            control={
              <StyledCheckbox
                checked={state.android}
                onChange={() => onChangeCheckbox('ANDROID', !state.android)}
                name="android"
              />
            }
            label="Android"
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          disabled={disabled}
          type="submit"
        >
          {formatMessage({ id: `contact.send` })}
        </Button>
      </Box>
    </form>
  );
};

export default EmailInputForm;
